/** Configuration, runtime status and diagnostic links for System & Betrieb. */

import type { ReactNode } from 'react';

import SettingsPanel from '../admin/SettingsPanel';

export function SystemOverviewPage(): ReactNode {
  return (
    <>
      <SettingsPanel />

      <div className="card">
        <div className="card-head">
          <h2>Weitere Oberflächen</h2>
        </div>
        <div className="card-body">
          {/*
            Server-rendered surfaces outside the SPA — plain anchors, in a new
            tab so the current console state survives.
          */}
          <div className="ops-links">
            <a href="/legacy/dashboard" target="_blank" rel="noreferrer">
              Legacy-Dashboard
            </a>
            <a href="/legacy/import" target="_blank" rel="noreferrer">
              Legacy-Import
            </a>
            <a href="/docs" target="_blank" rel="noreferrer">
              API-Dokumentation
            </a>
            <a href="/health" target="_blank" rel="noreferrer">
              Health-Endpunkt
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default SystemOverviewPage;
